import jsPDF from "jspdf";
import MogomaLogo from "../assets/logo.png";

export const createReportLayout = ({
    title,
    statementId,
    generatedAt,
}) => {
    const doc =
        new jsPDF(
            "p",
            "mm",
            "a4"
        );

    const pageWidth =
        doc.internal.pageSize.getWidth();

 

doc.addImage(
    MogomaLogo,
    "PNG",
    18,
    12,
    14,
    10
);

    doc.setFontSize(12);
    doc.setTextColor(
        36,
        83,
        255
    );

    doc.setFont(
        "helvetica",
        "bold"
    );

    doc.text(
        "Mogoma",
        37,
        18
    );

    doc.setFontSize(8);

    doc.setTextColor(
        120
    );

    doc.text(
        "OFFICIAL STATEMENT",
        37,
        22
    );

    doc.setFontSize(8);

    doc.text(
        "STATEMENT ID",
        pageWidth - 55,
        18
    );

    doc.setTextColor(
        20
    );

    doc.setFont(
        "helvetica",
        "bold"
    );

    doc.text(
        statementId,
        pageWidth - 55,
        23
    );

    doc.setTextColor(
        120
    );

    doc.setFont(
        "helvetica",
        "normal"
    );

    doc.text(
        "GENERATED ON",
        pageWidth - 55,
        30
    );

    doc.setTextColor(
        20
    );

    doc.text(
        generatedAt,
        pageWidth - 55,
        35
    );



    doc.setFontSize(20);

    doc.setFont(
        "helvetica",
        "bold"
    );

    doc.setTextColor(
        20
    );

    doc.text(
        title,
        15,
        55
    );

    doc.setDrawColor(
        230
    );

    doc.line(
        15,
        62,
        pageWidth - 15,
        62
    );

    return doc;
};